"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTagsInput = exports.mapTagObjectToList = exports.mapTagListToObject = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
var TagsInput_static_1 = require("./TagsInput.static");
var TagsInput_style_1 = __importDefault(require("./TagsInput.style"));
function mapTagListToObject(tags) {
    return (0, lodash_1.fromPairs)(tags.map(function (_a) {
        var key = _a.key, value = _a.value;
        return [key, value];
    }));
}
exports.mapTagListToObject = mapTagListToObject;
function mapTagObjectToList(tags) {
    return (0, lodash_1.map)(tags, function (value, key) { return ({ key: key, value: value }); });
}
exports.mapTagObjectToList = mapTagObjectToList;
function useTagsInput(_a) {
    var tags = _a.tags, tagNameValidator = _a.tagNameValidator, tagValueValidator = _a.tagValueValidator, onChange = _a.onChange, tagNameInputRef = _a.tagNameInputRef, tagValueInputRef = _a.tagValueInputRef;
    var _b = __read((0, react_1.useState)(''), 2), tagName = _b[0], setTagName = _b[1];
    var _c = __read((0, react_1.useState)(''), 2), tagValue = _c[0], setTagValue = _c[1];
    var _d = __read((0, react_1.useState)(), 2), nameError = _d[0], setNameError = _d[1];
    var _e = __read((0, react_1.useState)(), 2), valueError = _e[0], setValueError = _e[1];
    var tagNameTrimmedAndLowered = tagName.trim().toLowerCase();
    var tagValueTrimmed = tagValue.trim();
    var resetInputErrors = (0, react_1.useCallback)(function () {
        setNameError(undefined);
        setValueError(undefined);
    }, []);
    var handleAdd = (0, react_1.useCallback)(function () {
        var _a, _b, _c, _d, _e, _f;
        if (!tagNameTrimmedAndLowered) {
            (_a = tagNameInputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            return;
        }
        if (!tagValueTrimmed) {
            (_b = tagValueInputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            return;
        }
        var tagNameError = tagNameValidator(tagNameTrimmedAndLowered);
        if (tagNameError) {
            setNameError(tagNameError);
            (_c = tagNameInputRef.current) === null || _c === void 0 ? void 0 : _c.focus();
            return;
        }
        if (tags.some(function (_a) {
            var key = _a.key;
            return key.trim().toLowerCase() === tagNameTrimmedAndLowered;
        })) {
            setNameError(TagsInput_static_1.localText.nameAlreadyTakenError);
            (_d = tagNameInputRef.current) === null || _d === void 0 ? void 0 : _d.focus();
            return;
        }
        var tagValueError = tagValueValidator(tagValueTrimmed);
        if (tagValueError) {
            setValueError(tagValueError);
            (_e = tagValueInputRef.current) === null || _e === void 0 ? void 0 : _e.focus();
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(__spreadArray(__spreadArray([], __read(tags), false), [{ key: tagNameTrimmedAndLowered, value: tagValueTrimmed }], false));
        setTagName('');
        setTagValue('');
        resetInputErrors();
        (_f = tagNameInputRef.current) === null || _f === void 0 ? void 0 : _f.focus();
    }, [
        onChange,
        resetInputErrors,
        tagNameInputRef,
        tagNameTrimmedAndLowered,
        tagNameValidator,
        tagValueInputRef,
        tagValueTrimmed,
        tagValueValidator,
        tags,
    ]);
    var onKeyDown = (0, react_1.useCallback)(function (event) {
        if (event.key !== 'Enter') {
            return;
        }
        handleAdd();
    }, [handleAdd]);
    var onChangeTagName = (0, react_1.useCallback)(function (event) {
        resetInputErrors();
        setTagName(event.target.value);
    }, [resetInputErrors]);
    var onChangeTagValue = (0, react_1.useCallback)(function (event) {
        resetInputErrors();
        setTagValue(event.target.value);
    }, [resetInputErrors]);
    return {
        classes: (0, TagsInput_style_1.default)(),
        emptyInput: !tagNameTrimmedAndLowered || !tagValueTrimmed,
        handleAdd: handleAdd,
        nameError: nameError,
        valueError: valueError,
        onChangeTagName: onChangeTagName,
        onChangeTagValue: onChangeTagValue,
        onKeyDown: onKeyDown,
        tagName: tagName,
        tagValue: tagValue,
    };
}
exports.useTagsInput = useTagsInput;
